import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Email" }), /* @__PURE__ */ _jsx("path", {
		d: "M1.33331 2.66663L6.77659 6.47692C7.21737 6.78547 7.43776 6.93974 7.67749 6.9995C7.88924 7.05228 8.11072 7.05228 8.32247 6.9995C8.5622 6.93974 8.78259 6.78547 9.22337 6.47692L14.6666 2.66663M4.53331 11.3333H11.4666C12.5868 11.3333 13.1468 11.3333 13.5746 11.1153C13.951 10.9236 14.2569 10.6176 14.4487 10.2413C14.6666 9.81345 14.6666 9.2534 14.6666 8.13329V3.86663C14.6666 2.74652 14.6666 2.18647 14.4487 1.75865C14.2569 1.38232 13.951 1.07636 13.5746 0.884613C13.1468 0.666626 12.5868 0.666626 11.4666 0.666626H4.53331C3.41321 0.666626 2.85316 0.666626 2.42533 0.884613C2.04901 1.07636 1.74305 1.38232 1.5513 1.75865C1.33331 2.18647 1.33331 2.74652 1.33331 3.86663V8.13329C1.33331 9.2534 1.33331 9.81345 1.5513 10.2413C1.74305 10.6176 2.04901 10.9236 2.42533 11.1153C2.85316 11.3333 3.41321 11.3333 4.53331 11.3333Z",
		stroke: "black",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgMail;
